import React from 'react'

import useSwr from 'swr'

import { Form } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

const fetcher = () => TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.MEDIOSPAGOVENTAS).then(({ data }) => data)

const MedioPagoVentasSelect = props => {
  const { data: mediosPago } = useSwr('select_mediosPagoVentas', fetcher, {
    initialData: [],
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 1000 * 60 * 15
  })

  return (
    <Form.Select {...props}>
      <option value=''>Seleccionar</option>
      {mediosPago.map((val, key) => (
        <option key={key} value={val._id}>
          {val.nombre}
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(MedioPagoVentasSelect)
